import React from 'react';

const LayersIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2 11.4117C12.1369 11.4392 12.0688 11.4535 12 11.4535C11.9312 11.4535 11.8631 11.4392 11.8 11.4117L1.55501 6.95671C1.4657 6.91786 1.38968 6.85378 1.33629 6.77233C1.2829 6.69088 1.25446 6.5956 1.25446 6.49821C1.25446 6.40082 1.2829 6.30555 1.33629 6.2241C1.38968 6.14264 1.4657 6.07856 1.55501 6.03971L11.8 1.58471C11.8631 1.55718 11.9312 1.54297 12 1.54297C12.0688 1.54297 12.1369 1.55718 12.2 1.58471L22.445 6.03971C22.5343 6.07856 22.6103 6.14264 22.6637 6.2241C22.7171 6.30555 22.7456 6.40082 22.7456 6.49821C22.7456 6.5956 22.7171 6.69088 22.6637 6.77233C22.6103 6.85378 22.5343 6.91786 22.445 6.95671L12.2 11.4117Z"
      stroke="#4B4B4B"
    />
    <path
      d="M17.175 9.25L22.445 11.542C22.5343 11.5808 22.6103 11.6449 22.6637 11.7264C22.7171 11.8078 22.7456 11.9031 22.7456 12.0005C22.7456 12.0979 22.7171 12.1932 22.6637 12.2746C22.6103 12.3561 22.5343 12.4202 22.445 12.459L12.2 16.914C12.1369 16.9415 12.0688 16.9557 12 16.9557C11.9312 16.9557 11.8631 16.9415 11.8 16.914L1.55501 12.459C1.4657 12.4202 1.38968 12.3561 1.33629 12.2746C1.2829 12.1932 1.25446 12.0979 1.25446 12.0005C1.25446 11.9031 1.2829 11.8078 1.33629 11.7264C1.38968 11.6449 1.4657 11.5808 1.55501 11.542L6.82501 9.25"
      stroke="#4B4B4B"
    />
    <path
      d="M17.175 14.75L22.445 17.042C22.5343 17.0808 22.6103 17.1449 22.6637 17.2264C22.7171 17.3078 22.7456 17.4031 22.7456 17.5005C22.7456 17.5979 22.7171 17.6932 22.6637 17.7746C22.6103 17.8561 22.5343 17.9202 22.445 17.959L12.2 22.414C12.1369 22.4415 12.0688 22.4557 12 22.4557C11.9312 22.4557 11.8631 22.4415 11.8 22.414L1.55501 17.959C1.4657 17.9202 1.38968 17.8561 1.33629 17.7746C1.2829 17.6932 1.25446 17.5979 1.25446 17.5005C1.25446 17.4031 1.2829 17.3078 1.33629 17.2264C1.38968 17.1449 1.4657 17.0808 1.55501 17.042L6.82501 14.75"
      stroke="#4B4B4B"
    />
  </svg>
);

export default LayersIcon;
